import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, ChevronLeft, ChevronRight, ArrowLeft } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import FloatingActions from "../components/FloatingActions";
import { GALLERY_IMAGES } from "../mock/mock";

export default function Gallery() {
  const [idx, setIdx] = useState(null);
  const open = idx !== null;

  useEffect(() => { window.scrollTo(0, 0); }, []);
  useEffect(() => {
    const key = (e) => {
      if (!open) return;
      if (e.key === "Escape") setIdx(null);
      if (e.key === "ArrowLeft") setIdx((i) => (i === 0 ? GALLERY_IMAGES.length - 1 : i - 1));
      if (e.key === "ArrowRight") setIdx((i) => (i === GALLERY_IMAGES.length - 1 ? 0 : i + 1));
    };
    window.addEventListener("keydown", key);
    return () => window.removeEventListener("keydown", key);
  }, [open]);

  return (
    <div className="min-h-screen bg-white">
      <Header forceDark />

      <section className="pt-32 pb-16 px-6 bg-forge-off">
        <div className="max-w-6xl mx-auto text-center">
          <div className="text-[11px] tracking-[0.3em] uppercase text-forge-gold">Gallery</div>
          <h1 className="font-serif text-4xl md:text-5xl text-forge-navy mt-2">Life at Forge Stays</h1>
          <hr className="forge-divider" />
          <p className="text-forge-navy/70 max-w-2xl mx-auto">Take a closer look at Newry Street in Holyhead and Hotel Cymyran in Valley.</p>
          <div className="mt-6">
            <Link to="/" className="inline-flex items-center gap-2 text-forge-navy/70 hover:text-forge-gold text-sm">
              <ArrowLeft size={16} /> Back to Home
            </Link>
          </div>
        </div>
      </section>

      <section className="py-16 px-6">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {GALLERY_IMAGES.map((img, i) => (
            <div key={i} className="gallery-item aspect-[4/3]" onClick={() => setIdx(i)}>
              <img src={img.src} alt={img.alt} loading="lazy" />
              <div className="absolute inset-0 bg-forge-navy/0 hover:bg-forge-navy/25 transition-colors" />
            </div>
          ))}
        </div>
      </section>

      <Footer />
      <FloatingActions />

      {open && (
        <div className="fixed inset-0 z-[60] bg-black/85 flex items-center justify-center p-4" onClick={() => setIdx(null)}>
          <button className="absolute top-5 right-5 text-white/90 hover:text-white" onClick={() => setIdx(null)} aria-label="Close">
            <X size={30} />
          </button>
          <button className="absolute left-5 md:left-10 text-white/80 hover:text-white"
                  onClick={(e) => { e.stopPropagation(); setIdx((i) => (i === 0 ? GALLERY_IMAGES.length - 1 : i - 1)); }} aria-label="Previous">
            <ChevronLeft size={40} />
          </button>
          <img src={GALLERY_IMAGES[idx].src} alt={GALLERY_IMAGES[idx].alt}
               className="max-h-[85vh] max-w-[92vw] object-contain" onClick={(e) => e.stopPropagation()} />
          <button className="absolute right-5 md:right-10 text-white/80 hover:text-white"
                  onClick={(e) => { e.stopPropagation(); setIdx((i) => (i === GALLERY_IMAGES.length - 1 ? 0 : i + 1)); }} aria-label="Next">
            <ChevronRight size={40} />
          </button>
          <div className="absolute bottom-6 left-0 right-0 text-center text-white/85 text-sm tracking-wide">
            {GALLERY_IMAGES[idx].caption}
          </div>
        </div>
      )}
    </div>
  );
}
